import { AxiosResponse } from 'axios';
import { LookupResponse } from 'common/interfaces';
import { getFileDescriptionList } from 'components/aufgaben-component/utils';
import { useQuery } from 'react-query';

const modifyResponse = (response: AxiosResponse) => {
  return response.data.data?.map(({ id, name }: LookupResponse) => {
    return {
      label: name,
      value: id
    };
  });
};

export const useGetFileDescriptions = () => {
  const { data: fileDescriptions, isLoading: isFileDescriptionsLoading } = useQuery(
    ['files-description'],
    () => getFileDescriptionList(),
    { select: modifyResponse }
  );

  return { fileDescriptions: fileDescriptions || [], isFileDescriptionsLoading };
};
